class Facet
  constructor: ({ @key, @id, @title, @count, @children, @parent, @info, @type, @paramStore, @isChild, @isSelectAll, @defaults, @selected, @expanded, @locked, @hidden }) ->
    @active   = @paramStore.isActive @key, @id
    @disabled = @count is 0
    @isParent = Array.isArray @children
    @children = @_convertChildren @children
    @expanded = false if @isChild

  formattedCount: ->
    @count.toString().replace /\B(?=(\d{3})+(?!\d))/g, ','

  _convertChildren: (children) ->
    if @isParent
      new_children = [new Facet($.extend({}, @, parent: @, title: "All #{@title}", children: null, isChild: true, isSelectAll: true ))]
      new_children.push(new Facet($.extend({}, @, child, parent: @, children: null, isChild: true, isSelectAll: false))) for child in children
      new_children

LP.module('Searches').Facet = Facet
